import $ from "jquery";
import bdjs from "@bd-core/bdjs";

export default class Aspiration {
    constructor() {
        this.availableCoords = [];
        this.currentMaxKey = 0;
        this.itemKeys = [];

        // Options
        // --------------------------------------------------------------------
        this.itemWidth = 340;
        this.itemHeight = 120;
        this.elms = {
            aspiration: ".aspiration",
            inner: ".aspiration__wall",
            item: ".aspiration__wall .aspiration__item",
            itemOverload: ".aspiration__wall .aspiration__item.is-overload",
            itemCloned: ".aspiration__clone .aspiration__item",
            itemName: ".aspiration__name",
            itemMessage: ".aspiration__message",
            itemAvatar: ".aspiration__avatar",
            itemPerson: ".aspiration__person",
        };
        this.stateName = {
            overloadedItem: "is-overload",
            appendedItem: "is-appended",
            loading: "is-loading",
        };
    }

    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     * The value is no lower than min (or the next integer greater than min
     * if min isn't an integer) and no greater than max (or the next integer
     * lower than max if max isn't an integer).
     * Using Math.round() will give you a non-uniform distribution!
     *
     * @param {number} min Minimum range
     * @param {number} max Maximum range
     */
    getRandomInteger(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    setup() {
        if ($(this.elms.inner).length < 1) {
            return;
            // return console.error("Aspiration: inner element not found!");
        }

        const $aspiration = $(this.elms.aspiration);
        const $inner = $(this.elms.inner);
        const $aspirationItem = $(this.elms.item);
        const itemWidth = this.itemWidth;
        const itemHeight = this.itemHeight;
        const xIndexTotal = Math.floor($inner[0].clientWidth / itemWidth);
        const yIndexTotal = Math.floor($inner[0].clientHeight / itemHeight);

        // Will be filled with list of X,Y combination
        let initAvailableCoords = [];

        // Will be filled with number key of all items
        let initItemKeys = [];

        // Listing all the available coordinate
        for (let xIndex = 0; xIndex < xIndexTotal; xIndex++) {
            for (let yIndex = 0; yIndex < yIndexTotal; yIndex++) {
                const x = itemWidth * xIndex;
                const y = itemHeight * yIndex;
                const newCoordinate = { x, y };
                initAvailableCoords.push(newCoordinate);
            }
        }

        // Note: don't use arrow function, since we use `this` reference to the
        // HTMLElement itself
        const self = this;
        $aspirationItem.each(function (index) {
            if (initAvailableCoords.length > 0) {
                // Still have availableCoords slots
                // const maxRandomIndex = initAvailableCoords.length - 1;
                // const randomIndex = self.getRandomInteger(
                //     0,
                //     maxRandomIndex,
                // );

                // prettier-ignore
                // Get one coordinate and remove it from availableCoordinate list
                // const coordinate = initAvailableCoords.splice(randomIndex, 1)[0];

                $aspiration.removeClass(self.stateName.overloadedItem);
                initItemKeys.push(index);
                $(this).addClass("key-" + index);
                $(this).removeClass(self.stateName.overloadedItem);
            }
        });

        this.availableCoords = initAvailableCoords;
        this.itemKeys = initItemKeys;
        this.currentMaxKey = initItemKeys.length - 1;
        setTimeout(() => $aspiration.removeClass(self.stateName.loading), 500);
    }

    /**
     * Insert new Item to the aspiration wall
     *
     * @param {string} name
     * @param {string} message
     * @param {string} avatarURL
     * @param {string | string[]} classes
     * @param {boolean} [shouldScrollTo]
     */
    append(userID, name, message, avatarURL, classes, shouldScrollTo = true) {
        // const availableCoordinate = this.availableCoords;
        // const isAvailable = availableCoordinate.length > 0;
        const $aspiration = $(this.elms.aspiration);
        const $inner = $(this.elms.inner);
        // const $oldestItem = $(this.elms.item).first();
        const $clonedItem = $(this.elms.itemCloned);
        const $newItem = $clonedItem.clone();
        const currentKey = this.currentMaxKey + 1;
        const oldestKey = this.itemKeys[0];
        const defaultAvatar =
            "https://cdn-images-1.medium.com/fit/c/100/100/1*3ApyPDl5_ovc87cyvX7MMw.jpeg";
        avatarURL = avatarURL || defaultAvatar;
        // let coordinate;

        message = bdjs.escapeHtml(message);
        name = bdjs.escapeHtml(name);

        // const maxRandomIndex = availableCoordinate.length - 1;
        // const randomIndex = this.getRandomInteger(0, maxRandomIndex);

        this.currentMaxKey = currentKey;
        this.itemKeys.push(currentKey);
        $aspiration.removeClass(this.stateName.overloadedItem);

        // Remove attribute from cloned object
        $newItem.removeClass(this.stateName.overloadedItem);
        $newItem.removeClass("key-" + oldestKey);

        // Setup the string
        $newItem.find(this.elms.itemPerson).attr("data-user-id", userID);
        $newItem.find(this.elms.itemName).html(name);
        $newItem.find(this.elms.itemMessage).html(message);
        $newItem
            .find(this.elms.itemAvatar)
            .attr("src", avatarURL)
            .attr("alt", `${name}'s photo`);

        if (classes) {
            $newItem.addClass(classes);
        }

        // Set class for key tracking and animation
        $newItem.addClass(this.stateName.appendedItem);
        $newItem.addClass("key-" + currentKey);
        $inner.append($newItem);

        // var totalHeight = 0;

        // $('.aspiration__item').each(function(index ,element ) {
        //     totalHeight +=  $(element).height();
        // });

        $inner.css("height", $inner.prop("scrollHeight"));

        if (shouldScrollTo) {
            $aspiration.animate(
                { scrollTop: $inner.prop("scrollHeight") },
                100,
            );
        }
    }
}
